"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAccountType = exports.getIntlFormat = exports.IntlFormat = exports.StandardIntlDateFormat = exports.UserAttributeKeyDatePrecision = exports.AttributeMode = void 0;
exports.isGeofencePointsType = isGeofencePointsType;
var AttributeMode;
(function (AttributeMode) {
    AttributeMode[AttributeMode["readOnly"] = 0] = "readOnly";
    AttributeMode[AttributeMode["readWrite"] = 1] = "readWrite";
})(AttributeMode || (exports.AttributeMode = AttributeMode = {}));
/** numeric emun to access  */
var UserAttributeKeyDatePrecision;
(function (UserAttributeKeyDatePrecision) {
    UserAttributeKeyDatePrecision[UserAttributeKeyDatePrecision["Date"] = 0] = "Date";
    UserAttributeKeyDatePrecision[UserAttributeKeyDatePrecision["DateTimeMins"] = 1] = "DateTimeMins";
    UserAttributeKeyDatePrecision[UserAttributeKeyDatePrecision["DateTimeSecs"] = 2] = "DateTimeSecs";
})(UserAttributeKeyDatePrecision || (exports.UserAttributeKeyDatePrecision = UserAttributeKeyDatePrecision = {}));
/** standard time formats used in datamodel for UserAttributeDef precision and UI for subsequent display */
exports.StandardIntlDateFormat = {
    [UserAttributeKeyDatePrecision.Date]: { year: 'numeric', month: 'short', day: '2-digit' },
    [UserAttributeKeyDatePrecision.DateTimeMins]: { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' },
    [UserAttributeKeyDatePrecision.DateTimeSecs]: {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    },
};
exports.IntlFormat = {
    Date: exports.StandardIntlDateFormat[UserAttributeKeyDatePrecision.Date],
    DateTimeMins: exports.StandardIntlDateFormat[UserAttributeKeyDatePrecision.DateTimeMins],
    DateTimeSecs: exports.StandardIntlDateFormat[UserAttributeKeyDatePrecision.DateTimeSecs],
};
const getIntlFormat = ({ locales, timeZone, version }) => {
    return new Intl.DateTimeFormat(locales, { timeZone, ...exports.IntlFormat[version] });
};
exports.getIntlFormat = getIntlFormat;
function isGeofencePointsType(ob) {
    return ob && typeof ob.lat === 'number' && typeof ob.lng === 'number' && Math.abs(ob.lat) <= 90 && Math.abs(ob.lng) <= 180;
}
// export type { ValidationDef, UserAttributeDef, UserAttributeDefs, AlertStatus, AlertStateusKeys, MapObject}
// export type { GeofenceType, GeofencePointsType }
// export { mode }
var CustomerAccountType;
(function (CustomerAccountType) {
    CustomerAccountType["V"] = "Venture";
    CustomerAccountType["X"] = "Reseller";
    CustomerAccountType["Y"] = "Service Consumer / Reseller";
    CustomerAccountType["Z"] = "Service Consumer";
})(CustomerAccountType || (exports.CustomerAccountType = CustomerAccountType = {}));
